import { COMPETENCIES, MILESTONE_LEVELS } from '../lib/constants';

export default function Progress({ entries, isMobile }) {
  const compCounts = {};
  COMPETENCIES.forEach(c => { compCounts[c.id] = entries.filter(e => (e.competency_ids || []).includes(c.id)).length; });

  const levelDist = [1,2,3,4,5].map(n => ({
    n, label: MILESTONE_LEVELS.find(l=>l.n===n)?.label,
    count: entries.filter(e => e.milestone_level === n).length,
  }));
  const maxLevel = Math.max(...levelDist.map(l => l.count), 1);

  const completed = COMPETENCIES.filter(c => compCounts[c.id] >= c.min).length;
  const total = entries.length;

  return (
    <div style={{ background: '#F7F4F0', minHeight: '100vh', padding: isMobile ? '16px' : '36px 40px', paddingBottom: isMobile ? 80 : 36, maxWidth: isMobile ? '100%' : 1100, margin: '0 auto' }}>
      <h1 style={{ fontFamily: "'DM Serif Display'", fontSize: isMobile ? 22 : 30, color: '#1A1A1F', marginBottom: 4 }}>My Progress</h1>
      <p style={{ fontSize: 13, color: '#888', marginBottom: 20 }}>{completed} of {COMPETENCIES.length} targets reached · {total} total cases</p>

      {/* Level chart */}
      <div style={{ background: '#fff', borderRadius: 12, padding: isMobile ? '14px' : '22px 24px', marginBottom: 16, boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
        <div style={{ fontFamily: "'DM Serif Display'", fontSize: 16, color: '#1A1A1F', marginBottom: 16 }}>Milestone Distribution</div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end', height: 80 }}>
          {levelDist.map(l => (
            <div key={l.n} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
              <span style={{ fontSize: 12, fontWeight: 600, color: '#555' }}>{l.count}</span>
              <div style={{ width: '100%', background: '#2D6A8A', borderRadius: '4px 4px 0 0', height: `${Math.max(4, (l.count / maxLevel) * 56)}px` }} />
              <span style={{ fontSize: 10, color: '#888' }}>L{l.n}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Competency cards */}
      <div style={{ fontFamily: "'DM Serif Display'", fontSize: 16, color: '#1A1A1F', marginBottom: 12 }}>Competency Targets</div>
      <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(3,1fr)', gap: 10 }}>
        {COMPETENCIES.map(c => {
          const count = compCounts[c.id];
          const pct = Math.min(100, Math.round((count / c.min) * 100));
          const done = pct >= 100;
          return (
            <div key={c.id} style={{ background: '#fff', borderRadius: 10, padding: '14px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', borderTop: `3px solid ${c.color}` }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: '#1a1a1a', marginBottom: 8, lineHeight: 1.3 }}>{c.label}</div>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 4, marginBottom: 6 }}>
                <span style={{ fontFamily: "'DM Serif Display'", fontSize: 24, color: c.color }}>{count}</span>
                <span style={{ fontSize: 12, color: '#888' }}>/ {c.min}</span>
              </div>
              <div style={{ height: 4, background: '#EEE', borderRadius: 10, overflow: 'hidden' }}>
                <div style={{ height: '100%', borderRadius: 10, width: `${pct}%`, background: done ? '#1E5C40' : c.color }} />
              </div>
              <div style={{ fontSize: 10, color: done ? '#1E5C40' : '#888', marginTop: 5, fontWeight: done ? 600 : 400 }}>
                {done ? '✓ Target reached' : `${c.min - count} more needed`}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
